<template>
  <Teleport to="body">
    <div v-if="open" class="mv-sheet-overlay" @click="$emit('close')">
      <div class="mv-sheet" @click.stop>
        <div class="mv-sheet-handle"></div>
        <div class="mv-sheet-title">Atribuir agente</div>
        <div class="mv-agent-search-wrap">
          <input
            :value="agentSearch"
            @input="$emit('update:agentSearch', ($event.target as HTMLInputElement).value)"
            class="mv-agent-search"
            type="search"
            placeholder="Buscar agente…"
            autocomplete="off"
          />
        </div>
        <div v-if="agentLoading" class="mv-sheet-loading">
          <div class="mv-spinner" style="width:22px;height:22px;border-width:2px;"></div>
        </div>
        <div v-else class="mv-agent-list">
          <button class="mv-agent-opt" @click="$emit('assign', null)">
            <div class="mv-agent-av" style="background:#9CA3AF; color:#fff; font-size:12px; font-weight:700;">—</div>
            <span>Sem agente</span>
            <svg v-if="!currentAssigneeId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="margin-left:auto;flex-shrink:0"><polyline points="20 6 9 17 4 12"/></svg>
          </button>
          <button v-for="agent in filteredAgents" :key="agent.id" class="mv-agent-opt" @click="$emit('assign', agent.id)">
            <div class="mv-agent-av" :style="{ background: avatarColor(agent.name) }">
              <img
                v-if="agent.thumbnail"
                :src="agent.thumbnail"
                :alt="agent.name"
                @error="(e) => (e.target as HTMLImageElement).style.display='none'"
              />
              <span v-else>{{ initials(agent.name) }}</span>
            </div>
            <span>{{ agent.name }}</span>
            <svg v-if="currentAssigneeId === agent.id" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="margin-left:auto;flex-shrink:0"><polyline points="20 6 9 17 4 12"/></svg>
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import type { AgentItem } from '@/types/chat'
import { avatarColor, initials } from '@/composables/useHelpers'

defineProps<{
  open: boolean
  agentSearch: string
  agentLoading: boolean
  filteredAgents: AgentItem[]
  currentAssigneeId: number | null | undefined
}>()

defineEmits<{
  close: []
  'update:agentSearch': [value: string]
  assign: [agentId: number | null]
}>()
</script>

<style scoped>
/* Compartilhado com outros bottom sheets */
.mv-sheet-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.4);
  z-index: 2000;
  display: flex; flex-direction: column; justify-content: flex-end;
}
.mv-sheet {
  background: #fff;
  border-radius: 18px 18px 0 0;
  padding: 12px 0 max(20px, env(safe-area-inset-bottom));
  max-height: 72vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.mv-sheet-handle {
  width: 36px; height: 4px;
  background: #E5E7EB; border-radius: 2px;
  margin: 0 auto 14px;
}
.mv-sheet-title {
  font-size: 11.5px; font-weight: 700;
  color: #9CA3AF;
  text-transform: uppercase; letter-spacing: .7px;
  padding: 0 18px 8px;
}
.mv-sheet-loading { display: flex; justify-content: center; padding: 24px; }
.mv-spinner {
  width: 32px; height: 32px;
  border: 3px solid #E5E7EB;
  border-top-color: #BC0C24;
  border-radius: 50%;
  animation: spin .8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ══ Busca / lista de agentes ══ */
.mv-agent-search-wrap {
  padding: 0 14px 10px;
}
.mv-agent-search {
  width: 100%; box-sizing: border-box;
  border: 1.5px solid #E5E7EB; border-radius: 9px;
  padding: 9px 12px;
  font-size: 13px; font-family: 'Poppins', sans-serif; color: #1A1A1A;
  outline: none; background: #F9FAFB;
}
.mv-agent-search:focus { border-color: #BC0C24; background: #fff; }
.mv-agent-list { overflow-y: auto; }
.mv-agent-opt {
  display: flex; align-items: center; gap: 12px;
  width: 100%; padding: 13px 18px;
  background: none; border: none;
  border-bottom: 1px solid #F3F4F6;
  font-size: 14px; font-weight: 500; color: #1A1A1A;
  font-family: 'Poppins', sans-serif;
  cursor: pointer; text-align: left;
  -webkit-tap-highlight-color: transparent;
}
.mv-agent-opt:active { background: #F7F7F7; }
.mv-agent-opt:last-child { border-bottom: none; }
.mv-agent-av {
  width: 32px; height: 32px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; overflow: hidden;
  font-size: 11px; font-weight: 700; color: #fff;
}
.mv-agent-av img { width: 100%; height: 100%; object-fit: cover; }
</style>
